import { ChevronDownIcon } from '@heroicons/react/20/solid'
import { FC, useMemo, useState } from 'react'

import { NotificationApiType } from '@/api/models/notifications/lib/notifications.types'
import { cn } from '@/app/utils'

type Props = {
  className?: string
  item: NotificationApiType
}

const messageMaxLength = 121

const NotificationCardBody: FC<Props> = ({ className, item }) => {
  const [expanded, setExpanded] = useState(false)

  const message = item.description

  const formattedMessage = useMemo(() => {
    if (message.length < messageMaxLength) {
      return message
    }

    return expanded ? message : message.slice(0, messageMaxLength) + '...'
  }, [expanded, message])

  const canExpand = message.length > messageMaxLength

  return (
    <div className={className}>
      <div
        className={cn(
          'mt-4 max-h-[90px] overflow-hidden text-ellipsis font-pro transition-all duration-700 ease-linear text-18 lg:text-16 sm:text-14',
          expanded && 'max-h-[500px] break-words'
        )}
      >
        {formattedMessage}
      </div>

      {canExpand && (
        <button
          aria-label={
            expanded ? 'Свернуть уведомление' : 'Показать уведомление полностью'
          }
          title={expanded ? 'Свернуть' : 'Показать полностью'}
          className="group mt-16 flex w-full items-center justify-center border-t border-grey-30 py-4"
          onClick={event => {
            event.stopPropagation()
            setExpanded(!expanded)
          }}
        >
          <ChevronDownIcon
            className={cn(
              'h-20 w-20 transition-transform group-hover:translate-y-2',
              expanded && '-scale-100 group-hover:-translate-y-2'
            )}
          />
        </button>
      )}
    </div>
  )
}

export default NotificationCardBody
